module.exports = __webpack_public_path__ + "media/app/images/logo-a99db09cf85f8c09dbed85f80516eefd.png";